import { App } from "antd"
import {
  useContext,
  useState
} from "react"
import {
  useNavigate
} from "react-router-dom"
import {
  Container,
  FullRow,
  RowButton,
  RowInput,
  Title
} from "../../components"
import { hashPassword, sha256 } from "../../config"
import { UserContext } from "../../context"
import { changePassword } from "../../endpoints"



export function ChangePassword(): JSX.Element {
  const [oldPassword, setOldPassword] = useState("")
  const [password, setPassword] = useState("")
  const [password2, setPassword2] = useState("")
  const user = useContext(UserContext)
  const{modal}=App.useApp()
  const navigate = useNavigate()

  const handleSubmit = async () => {
    if (password !== password2) {
     modal.warning({
        title: "warning",
        content: "The passwords do not match, please type again",
      })
      return
    }

    if (!password||!oldPassword) {
      modal.warning({ title: "warning", content: "Password fields cannot be empty" })
      return
    }

    if (user.user && user.user?.email && password.length > 0 && oldPassword.length>0) {
      const oldpassword = await sha256(oldPassword + "plab")
      const hash = await hashPassword(await sha256(password + "plab"))
      console.log("register hash", hash)

      const res = await changePassword({
        email: user.user.email,
        password: hash,
        oldpassword
      })
      // consolelog("res", res)
      if (res.code === 1000) {
        navigate(res.message)
      } else {
        modal.warning({ content: res.message })
      }
    }
    
  }
  if(!user.user || !user.user.email)
    return <div>error</div>
  return (
    <Container style={{ marginTop: "3.5em" }}>
      <FullRow>
        <Title>Change Password</Title>
      </FullRow>
      <FullRow>
        <RowInput
          placeholder="Old Password"
          type="password"
          id="oldpassword"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
          name="oldpassword"
          maxLength={40}
        />
      </FullRow>

      <FullRow>
        <RowInput
          placeholder="New Password"
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          name="password"
          maxLength={40}
        />
      </FullRow>
      <FullRow>
        <RowInput
          placeholder="Retype New Password"
          type="password"
          id="password2"
          value={password2}
          onChange={(e) => setPassword2(e.target.value)}
          name="password2"
          maxLength={40}
        />
      </FullRow>
      <FullRow>
        <RowButton type="primary" onClick={handleSubmit} id="submit">
          Submit
        </RowButton>
      </FullRow>
    </Container>
  )
}
